// extracted by mini-css-extract-plugin
module.exports = {"appWidth":"layout-module--appWidth--3pBYr","docWidth":"layout-module--docWidth--3aSGN"};